import { addHours, isPast } from "date-fns";

interface StorageItem {
    storage_location: string;
    expiration: string;
}

export const getTokenFromStorage = <T>(
    key: string
): (T & StorageItem) | undefined => {
    let item: T & StorageItem;
    let isLocal: boolean = true;
    let storeItem = localStorage.getItem(key);
    if (!storeItem) {
        storeItem = sessionStorage.getItem(key);
        isLocal = !storeItem;
    }

    if (!!storeItem) {
        try {
            item = JSON.parse(storeItem);

            const { expiration } = item as StorageItem;

            if (expiration !== undefined && isPast(new Date(expiration))) {
                removeKeyFromStorage(key);
                return undefined;
            }

            (item as StorageItem).storage_location = isLocal
                ? "local"
                : "session";
            return item || undefined;
        } catch (e) {
            return undefined;
        }
    }

    return undefined;
};

export const storeTokenInStorage = (
    key: string,
    token: any,
    storageType: "local" | "session" = "local",
    expirationInHours: number = 0
) => {
    if (expirationInHours > 0) {
        token.expiration = addHours(new Date(), expirationInHours);
    }

    const data = JSON.stringify(token);
    if (storageType === "local") {
        localStorage.setItem(key, data);
    } else sessionStorage.setItem(key, data);
};

export const removeKeyFromStorage = (
    key: string,
    storageType: "local" | "session" = "local"
) => {
    if (storageType === "local") localStorage.removeItem(key);
    if (storageType === "session") sessionStorage.removeItem(key);
};

export const getKeyFromStorage = (
    key: string,
    storageType: "local" | "session" = "local"
) => {
    if (storageType === "local") return localStorage.getItem(key);
    if (storageType === "session") return sessionStorage.getItem(key);
};

export const setKeyInStorage = (
    key: string,
    value: string,
    storageType: "local" | "session" = "local"
) => {
    if (storageType === "local") localStorage.setItem(key, value);
    if (storageType === "session") sessionStorage.setItem(key, value);
};
